const namespace = 'recent/history/'

// Getters
export const HISTORY = 'history'
export const RECENT_HISTORY = namespace + HISTORY

// Mutators
export const ADD_HISTORY = 'addHistory'
export const REMOVE_HISTORY = 'removeHistory'
export const PURGE_HISTORY = 'purgeHistory'

export const RECENT_ADD_HISTORY = namespace + ADD_HISTORY
export const RECENT_REMOVE_HISTORY = namespace + REMOVE_HISTORY
export const RECENT_PURGE_HISTORY = namespace + PURGE_HISTORY



// WEBPACK FOOTER //
// ./src/store/recent/recentHistoryModule.types.js